"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export function HeroSection() {
    return (
        <section className="relative min-h-[80vh] flex flex-col items-center justify-center px-4 pt-32 pb-20 overflow-hidden bg-background">
            {/* Subtle Grid Background */}
            <div className="absolute inset-0 z-0 bg-[linear-gradient(to_right,#8080800a_1px,transparent_1px),linear-gradient(to_bottom,#8080800a_1px,transparent_1px)] bg-[size:14px_24px]" />

            <div className="container mx-auto text-center z-10 max-w-4xl">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="flex justify-center mb-8"
                >
                    <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-card border border-border text-xs font-medium text-muted-foreground">
                        <span className="flex h-2 w-2 rounded-full bg-primary" />
                        v1.0 is live
                    </div>
                </motion.div>

                <motion.h1
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                    className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight mb-8 text-foreground"
                >
                    stop shipping bugs
                    <br />
                    <span className="text-muted-foreground">to production.</span>
                </motion.h1>

                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-12 leading-relaxed"
                >
                    ai-powered code reviews for every pull request.
                    catch security flaws, bugs, and code smells before they reach your users.
                </motion.p>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                    className="flex items-center justify-center gap-4 flex-wrap"
                >
                    <Link href="/sign-up">
                        <Button
                            size="lg"
                            className="h-12 px-8 rounded-lg text-base bg-foreground text-background cursor-pointer hover:bg-foreground/90 font-medium"
                        >
                            get started free
                            <ArrowRight className="ml-2 h-4 w-4" />
                        </Button>
                    </Link>
                    <Link href="https://github.com/apps/burg-ai" target="_blank">
                        <Button
                            variant="outline"
                            size="lg"
                            className="h-12 px-8 rounded-lg text-base border-border cursor-pointer hover:bg-card"
                        >
                            view docs
                        </Button>
                    </Link>
                </motion.div>

                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.4 }}
                    className="text-sm text-muted-foreground mt-8"
                >
                    byok supported: openai • anthropic • gemini • openrouter
                </motion.p>
            </div>
        </section>
    );
}
